import { lazy, Suspense, useState } from 'react'
import Flex from '@dd3tech/wiggui/Flex'
import Badge from '@dd3tech/wiggui/Badge'
import { MdOutlineLogin } from 'react-icons/md'
import { composeClasses } from '../../../../utils/src/strings'

const STAGE = process.env.NEXT_PUBLIC_STAGE
const IS_LOCAL = STAGE === 'local'

const ModalLogin = lazy(
  () => import('../../../components/modal-login/ModalLogin')
)

interface ButtonModalLoginProps {
  isShowText: boolean
  isShowBadge: boolean
}

export const ButtonModalLogin = ({
  isShowText,
  isShowBadge
}: ButtonModalLoginProps) => {
  const [isOpenModalLogin, setIsOpenModalLogin] = useState(false)

  return (
    <>
      {IS_LOCAL && isOpenModalLogin && (
        <Suspense fallback={null}>
          <ModalLogin onClose={() => setIsOpenModalLogin(false)} />
        </Suspense>
      )}
      {IS_LOCAL && (
        <button
          type="button"
          onClick={() => setIsOpenModalLogin(true)}
          className={composeClasses(
            'flex justify-between w-full items-center gap-2.5 h-10 min-h-[40px] px-[10px] rounded-xl bg-surface-gray-10 hover:bg-[#DEE5F1] active:bg-[#b6bbc5] transition-colors duration-300 ease-in-out'
          )}
        >
          <Flex
            dir="row"
            items="center"
            justify="start"
            gap="gap-3"
            wFull={isShowText}
          >
            <MdOutlineLogin className="min-w-[18px] min-h-[18px] text-primary" />
            {isShowText && (
              <p
                title="Iniciar sesión"
                className="text-primary text-body-m whitespace-nowrap text-ellipsis overflow-hidden w-full max-w-[70px]"
              >
                Iniciar sesión
              </p>
            )}
          </Flex>
          {isShowBadge && (
            <Badge type="green" variant="light" size="small" value="LOCAL" />
          )}
        </button>
      )}
    </>
  )
}
